// src/pages/LoginPage.js
import React, { useState, useContext } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import AuthContext from '../context/AuthContext.js';
import { Button, TextField, Container, Typography, Box } from '@mui/material'; // Usando MUI

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const { login, isAuthenticated } = useContext(AuthContext);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        const result = await login(email, password);
        if (result === true) {
            navigate('/dashboard'); // Redirige al dashboard si el login es exitoso
        } else {
            setError(result); // Muestra el mensaje de error
        }
    };
    
    // Si el usuario ya está autenticado, no debe ver la página de login
    if (isAuthenticated) {
        return <Navigate to="/dashboard" />;
    }

    return (
        <Container component="main" maxWidth="xs">
            <Box sx={{ marginTop: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <img src="https://points.beer/logo_pointsbeer.png" alt="Logo" style={{ width: 200, marginBottom: 20 }} />
                <Typography component="h1" variant="h5">
                    Iniciar Sesión
                </Typography>
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="email"
                        label="Correo Electrónico"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Contraseña"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
                    <Button type="submit" fullWidth variant="contained" sx={{ mt: 3, mb: 2 }}>
                        Entrar
                    </Button>
                </Box>
            </Box>
        </Container>
    );
};

export default LoginPage;